<template>
  <div class="search-wrap" @click.stop>
    <span class="current" @click="showTypes = true">
      <span v-if="type">{{ type.value }}</span>
      <img class="down" src="@/assets/images/common/arrow-down@2x.png" />
    </span>
    <input
      ref="searchInput"
      class="search-input"
      type="text"
      v-model="keywords"
      :placeholder="placeholder"
      @input="searchSuggest"
      @keydown.up="searchSuggestUp"
      @keydown.down="searchSuggestDown"
      @keydown.enter="onInputEnter()"
    />
    <img class="close" src="@/assets/images/close@2x.png" @click="showSearch = false" />
    <div class="search-suggest">
      <div
        class="search-suggest-item"
        :class="{ active: searchSuggestIndex == index }"
        v-for="(item, index) in searchSuggestItems"
        :key="item.id"
        @click="onSearchSuggestClick(item)"
        v-html="item.title"
      ></div>
      <div
        class="search-suggest-item"
        v-if="searchSuggestItems.length == 0 && keywords && searchSuggestComplete"
      >
        暂无内容
      </div>
    </div>
    <div v-if="showTypes" class="types">
      <a class="type" v-for="type in types" :key="type.key" @click="onTypeClick(type)">
        {{ type.value }}
      </a>
    </div>
  </div>
</template>
<script>
import { Enum } from '@/utils/enums';

export default {
  name: 'HeaderSearch',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSearch: this.show,
      keywords: this.$store.state.search,
      searchSuggestFuction: null,
      searchSuggestItems: [],
      searchSuggestIndex: -1,
      searchSuggestComplete: false,
      searchType: '',
      searchHandles: {},
      showTypes: false,
    };
  },
  computed: {
    placeholder() {
      if (this.searchType == this.searchTypes.Course) {
        return '请输入课程名称';
      } else if (this.searchType == this.searchTypes.CoursePackage) {
        return '请输入组合课程名称';
      } else if (this.searchType == this.searchTypes.Book) {
        return '请输入实物商品名称';
      } else if (this.searchType == this.searchTypes.Periods) {
        return '请输入课时包名称';
      }
      return '';
    },
    searchTypes() {
      let config = this.$store.state.commonSetting;
      let types = [
        {
          id: 1,
          name: '课程',
          code: 'Course',
        },
        {
          id: 5,
          name: '组合课程',
          code: 'CoursePackage',
          hide: config.switch_package_course != 1,
        },
        {
          id: 4,
          name: '实物商品',
          code: 'Goods',
          hide: config.switch_goods_module != 1,
        },
        {
          id: 6,
          name: '课时包',
          code: 'Periods',
          hide: config.switch_contract_schedule != 1,
        },
      ];
      let searchTypes = new Enum(types.filter((t) => t.hide != true));
      return searchTypes;
    },
    types() {
      return this.searchTypes.getOptions();
    },
    type() {
      return this.types.find((t) => t.key == this.searchType);
    },
  },
  watch: {
    show(newValue) {
      this.showSearch = newValue;
      if (!newValue) {
        this.keywords = '';
        this.searchSuggestItems = [];
      }
    },
    showSearch(newValue) {
      this.$emit('update:show', newValue);
    },
    searchTypes() {
      this.init();
    },
  },
  created() {
    this.init();
    this.searchHandles = {
      [this.searchTypes.Course]: {
        search: () => {
          this.$router.push({
            name: 'Course',
            query: { keywords: this.keywords },
          });
        },
        searchSuggestClick: (item) => {
          if (item.course_type == 3) {
            this.$router.push({
              name: 'CourseShow',
              params: { id: item.id },
              query: { recommend: 3, title: '公开课' },
            });
          } else {
            this.$router.push({ name: 'CourseShow', params: { id: item.id } });
          }
        },
      },
      [this.searchTypes.Goods]: {
        search: () => {
          this.$router.push({
            name: 'Goods',
            query: { keywords: this.keywords },
          });
        },
        searchSuggestClick: (item) => {
          this.$router.push({ name: 'GoodsDetail', params: { id: item.id } });
        },
      },
      [this.searchTypes.CoursePackage]: {
        search: () => {
          this.$router.push({
            name: 'Package',
            query: { keywords: this.keywords },
          });
        },
        searchSuggestClick: (item) => {
          this.$router.push({
            name: 'PackageDetail',
            params: { id: item.id },
          });
        },
      },
      [this.searchTypes.Periods]: {
        search: () => {
          this.$router.push({
            name: 'Periods',
            query: { keywords: this.keywords },
          });
        },
        searchSuggestClick: (item) => {
          this.$router.push({
            name: 'PeriodsDetail',
            params: { id: item.id },
          });
        },
      },
    };
  },
  async mounted() {
    await this.$nextTick();
    this.$refs.searchInput.focus();
    document.addEventListener('click', () => {
      this.showSearch = false;
    });
  },
  methods: {
    init() {
      this.searchType = this.searchTypes.Course;
    },
    onTypeClick(type) {
      this.searchType = type.key;
      this.showTypes = false;
    },
    search() {
      this.showSearch = false;
      let handle = this.searchHandles[this.searchType];
      if (handle) {
        handle.search();
      }
    },
    searchSuggest() {
      this.searchSuggestComplete = false;
      if (!this.keywords) {
        this.searchSuggestItems = [];
        return;
      }
      if (!this.searchSuggestFuction) {
        this.searchSuggestFuction = this.$pub.debounce(async () => {
          if (!this.keywords) {
            this.searchSuggestItems = [];
            return;
          }
          let list = await this.$http.get('/api/app/keywords', {
            type: this.searchType,
            course_type: this.searchType == 7 ? 3 : this.searchType == 1 ? 1 : '',
            keywords: encodeURIComponent(this.keywords),
          });
          list.forEach((item) => {
            item.title = item.title.replace(
              new RegExp(this.keywords, 'g'),
              '<span class="primary-color">' + this.keywords + '</span>',
            );
          });
          this.searchSuggestItems = list;
          this.searchSuggestIndex = -1;
          this.searchSuggestComplete = true;
        }, 200);
      }
      this.searchSuggestFuction();
    },
    searchSuggestUp() {
      if (this.searchSuggestIndex == -1) {
        return;
      }
      this.searchSuggestIndex--;
    },
    searchSuggestDown() {
      if (this.searchSuggestIndex == this.searchSuggestItems.length - 1) {
        return;
      }
      this.searchSuggestIndex++;
    },
    onSearchSuggestClick(item) {
      item = item || this.searchSuggestItems[this.searchSuggestIndex];
      if (!item) {
        return;
      }
      let handle = this.searchHandles[this.searchType];
      if (handle) {
        handle.searchSuggestClick(item);
      }
      this.showSearch = false;
      this.searchSuggestIndex = -1;
    },
    onInputEnter() {
      if (this.searchSuggestIndex >= 0) {
        this.onSearchSuggestClick();
      } else {
        this.search();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.search-wrap {
  position: absolute;
  z-index: 9;
  left: 50%;
  top: 16px;
  transform: translateX(-50%);
  width: 644px;
  line-height: 36px;
  height: 38px;
  background: white;
  display: flex;
  align-items: center;
  border: 1px solid #dbdbdb;
  border-radius: 20px;
  box-sizing: border-box;
  padding: 8px 18px 8px 20px;

  .current {
    cursor: pointer;
  }

  .down {
    width: 12px;
    height: 7px;
    margin: 0 10px 0 12px;
  }

  .close {
    width: 14px;
    height: 14px;
    cursor: pointer;
  }

  .types {
    width: 160px;
    opacity: 1;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
    position: absolute;
    left: 8px;
    top: 42px;
    padding: 4px 0;
  }

  .type {
    cursor: pointer;
    display: block;
    color: #333;
    text-align: left;
    height: 36px;
    padding-left: 12px;

    &:hover {
      background: rgba($color: $primary-color, $alpha: 0.08);
    }

    &:active {
      color: $primary-color;
    }
  }
}

.search-input {
  flex-grow: 1;
  background: none;
  height: 32px;
  line-height: 32px;
  border: none;
  outline: none;
  color: #333333;
  box-sizing: border-box;
  caret-color: #ccc;

  &::placeholder {
    color: #ccc;
  }
}

.search-suggest {
  width: 604px;
  background: white;
  position: absolute;
  top: 42px;
  box-shadow: 0px 4px 12px 0px rgba(90, 90, 90, 0.15);
  text-align: left;
  max-height: calc(100vw * 420 / 1920);
  overflow-y: auto;
}

.search-suggest-item {
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  box-sizing: border-box;

  &:hover,
  &.active {
    background: #f0f0f0;
  }
}
</style>
